import { API_URL } from '../../../Utils/settings';

export const getCalenderEventsUrl = API_URL + '/pick-my-trade/get-calendar';
